import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=65e73ba8&scoped=true&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"
import style0 from "./Triangle.vue?vue&type=style&index=0&id=65e73ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e73ba8",
  null
  
)

export default component.exports